export enum NoteCollectionName {
    Location = 'location',
    // LocationMapComment = 'locationMapComment', // Did this become the mapping collection?
    Mapping = 'mapping',
    Company = 'company',
    WorkOrder = 'workOrder'
}
